module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right common_save_btn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'helperAndDriver'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Cancel ")])]), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": function($event) {
        return _vm.createHelperAndDriver(_vm.formstate)
      }
    }
  }, [_vm._v(" Save ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !(
        (_vm.formstate.$dirty || _vm.isUserRoleChange || _vm.isFileChange) &&
        _vm.formstate.$valid
      )
    },
    on: {
      "click": _vm.updateHelperAndDriver
    }
  }, [_vm._v(" Update ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body details_scrollbar"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "common_bdr",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("City "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select your City")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.cityId),
      expression: "helperAndDriver.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') || _vm.isCityDisable
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.helperAndDriver, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.citys), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id
      }
    }, [_vm._v(_vm._s(cityId.name) + "\n                          ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("First Name "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Please fill your First Name")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.firstName),
      expression: "helperAndDriver.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "firstName",
      "required": "",
      "placeholder": "First Name",
      "pattern": "^(?=[A-Z])[A-Za-z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.helperAndDriver.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "firstName", $event.target.value)
      }, function($event) {
        return _vm.capitalizeFirstName()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("First Name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" Alphabets are allowed and upto 25 characters. ")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Last Name "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Please fill your Last Name")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.lastName),
      expression: "helperAndDriver.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "lastName",
      "required": "",
      "placeholder": "Last Name",
      "pattern": "^(?=[A-Z])[A-Za-z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.helperAndDriver.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "lastName", $event.target.value)
      }, function($event) {
        return _vm.capitalizeLastName()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Last Name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" Alphabets are allowed and upto 25 characters. ")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.role),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("User Role Type "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select your User Role Type")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.role),
      expression: "helperAndDriver.role"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "role"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.helperAndDriver, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getRolesPermission($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select User Role Type")]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role._id,
        "selected": role &&
          _vm.helperAndDriver.role &&
          role._id === _vm.helperAndDriver.role
      }
    }, [_vm._v(_vm._s(role.role))])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "role",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("User Role is required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobile),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Contact Number "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Please fill your Contact Number")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.mobile),
      expression: "helperAndDriver.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "maxlength": "10",
      "type": "string",
      "name": "mobile",
      "placeholder": "Contact",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.helperAndDriver.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobile",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Contact number is invalid")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.idProof),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("ID Proof 1")]), _vm._v(" "), _c('span', [_vm._v("Please fill upload your ID Proof 1")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "fileName"
    }
  }, [(!_vm.isFileChange1) ? _c('img', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/downloadIcon.png"),
      "alt": "downloadIcon.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFileChange1) ? _c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/showIcon.png"),
      "alt": "showIcon.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFileChange1) ? _c('span', [_vm._v(_vm._s(this.licenceName1))]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileName",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "name": "otherInfo"
    },
    on: {
      "change": _vm.onDocumentchanged1
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "otherInfo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" Please upload less than 5mb ID Proof 1 ")])]), _vm._v(" "), (_vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.helperAndDriver.idFront
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.helperAndDriver.idFront,
      "target": "_blank"
    }
  }, [_vm._v(" View ")])]) : _vm._e()], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.idProof),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("ID Proof 2")]), _vm._v(" "), _c('span', [_vm._v("Please fill upload your ID Proof 2")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "fileName1"
    }
  }, [(!_vm.isFileChange2) ? _c('img', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/downloadIcon.png"),
      "alt": "downloadIcon.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFileChange2) ? _c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/showIcon.png"),
      "alt": "showIcon.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFileChange2) ? _c('span', [_vm._v(_vm._s(this.licenceName2))]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileName1",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "name": "otherInfo"
    },
    on: {
      "change": _vm.onDocumentchanged2
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "otherInfo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" Please upload less than 5mb ID Proof 2 ")])]), _vm._v(" "), (_vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.helperAndDriver.idBack
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.helperAndDriver.idBack,
      "target": "_blank"
    }
  }, [_vm._v(" View ")])]) : _vm._e()], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('div', {
    class: {
      'required-field': _vm.roleName === 'Surveyor' ||
        _vm.roleName === 'Plant Manager' ||
        _vm.roleName === 'Dump Yard Manager' ||
        _vm.roleName === 'Supervisor' ||
        _vm.roleName === 'Report Manager' ||
        _vm.roleName === 'Monitoring Manager' ||
        _vm.roleName === 'City SubAdmin',
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('span', [_vm._v("Please fill your Email")])])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.email),
      expression: "helperAndDriver.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": _vm.roleName === 'Surveyor' ||
        _vm.roleName === 'Plant Manager' ||
        _vm.roleName === 'Dump Yard Manager' ||
        _vm.roleName === 'Supervisor' ||
        _vm.roleName === 'Report Manager' ||
        _vm.roleName === 'Monitoring Manager' ||
        _vm.roleName === 'City SubAdmin' ?
        true :
        false,
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.helperAndDriver.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v("Email is invalid")])])], 1)])], 1)])]), _vm._v(" "), (_vm.showDriverDetails) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.expiryDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', {
    attrs: {
      "for": "expiryDate"
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('span', [_vm._v("Select your Expiry Date")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('date-picker', {
    attrs: {
      "id": "expiryDate",
      "not-before": _vm.beforeDisable,
      "lang": "en",
      "name": "expiryDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.helperAndDriver.expiryDate),
      callback: function($$v) {
        _vm.$set(_vm.helperAndDriver, "expiryDate", $$v)
      },
      expression: "helperAndDriver.expiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "expiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Expiry date is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Expiry date is invalid")])])], 1)])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.licenceNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("License Number "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Please fill your License Number")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.licenceNumber),
      expression: "helperAndDriver.licenceNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "licenceNumber",
      "maxlength": "16",
      "required": "",
      "placeholder": "License Number",
      "pattern": "^[a-zA-Z0-9 -]{0,16}[^\\s]$"
    },
    domProps: {
      "value": (_vm.helperAndDriver.licenceNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "licenceNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "licenceNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" License Number is a required field ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" License Number should have only alphabet and numeric characters without special. ")])])], 1)])], 1)])]), _vm._v(" "), (_vm.showPin) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.pin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("PIN "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Please fill your PIN")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.pin),
      expression: "helperAndDriver.pin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "string",
      "minlength": "4",
      "maxlength": "4",
      "name": "pin",
      "required": "",
      "placeholder": "PIN",
      "pattern": "^\\d{4}$"
    },
    domProps: {
      "value": (_vm.helperAndDriver.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "pin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" PIN is a required field. ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" Numbers are allowed. ")])])], 1)])], 1)]), _vm._v(" "), (_vm.showPasswordField) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.pin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Password "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input_relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helperAndDriver.pin),
      expression: "helperAndDriver.pin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "maxlength": "25",
      "name": "pin",
      "required": "",
      "placeholder": "Password",
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$#!%*?&]{8,}$"
    },
    domProps: {
      "value": (_vm.helperAndDriver.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperAndDriver, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fa fa-eye passwordView",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showPassword
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "pin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" Password is a required field ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" Password should have at least one uppercase letter, one lowercase letter, one number and one special character. ( eg: Xyz@1234 ) ")])])], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showDriverDetails) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.helperAndDriverGpsId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Device Identifier")]), _vm._v("\n                    " + _vm._s((" : " + (this.helperAndDriverGpsId) + " ")) + "\n                    "), _c('div', {
    staticClass: "captcha-input-container",
    staticStyle: {
      "position": "relative"
    }
  }, [(!this.helperAndDriverGpsId) ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refreshCaptcha
    }
  }, [_vm._v(" Generate ")]) : _vm._e()]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "helperAndDriverGpsId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("PIN is a required field.")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Numbers are allowed.")])])], 1)], 1) : _vm._e()])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a035ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/helperAndDriverManagment/helperAndDriverCreate.vue
// module id = 2290
// module chunks = 1